module["exports"] = [
  "BV",
  "V.O.F.",
  "Groep",
  "NV",
  "Bedrijf", 
  "en Zonen",
  "Combinatie"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/company/suffix.js
// module id = 3290
// module chunks = 1610